var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-whatsapp btn-whatsapp-fixed s-1",class:_vm.scroll_bottom ? 'appear' : 'disappear',on:{"click":_vm.toWhatsApp}},[_c('img',{attrs:{"src":require("@/assets/whastapp.png")}}),_c('p',[_vm._v(" Pregunta lo que necesites... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }